import * as service from "../service";
import { store } from "../../store";

export type UploadSocietyChopParams = {
  society_id: string;
  /** Cloudinary URL of the uploaded chop. */
  chop_image_url: string;
};

export type UploadSocietyChopResult = {
  id: string;
  chop_image_url: string | null;
};

/**
 * Persist a society chop against the society row.
 * Backend: POST /api/society/uploadChop
 */
export const UploadSocietyChopAPI = async (
  params: UploadSocietyChopParams,
): Promise<
  | { status: number; result?: UploadSocietyChopResult; message?: string; error?: any }
  | null
> => {
  const { student } = store.getState().auth as any;
  try {
    const resp = await service.call("POST", "api/society/uploadChop", {
      user_id: student?.id,
      ...params,
    });
    return resp;
  } catch (err) {
    console.error(`UploadSocietyChopAPI ${err}`);
    return null;
  }
};
